import { Injectable } from '@angular/core'

import {
  COLLECTIVE_INVESTMENT_TRUST,
  ETF,
  TRUST,
} from '../../../constants/constant.content'
import { IProduct } from '../../models/product'
import { ClassificationRulesService } from '../classification-rules/classification-rules.service'
import { UtilityService } from '../utility-service/utility-service.service'

@Injectable({
  providedIn: 'root',
})
export class ProductTypeRulesService {
  public static isETF(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      UtilityService.wordMatch(product.fundShareClass, ETF)
    )
  }
  public static isMutualFund(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      product.distributionGroupCodes.includes('G010') &&
      !ProductTypeRulesService.isETF(product)
    )
  }
  public static isCollectiveTrust(product: IProduct) {
    return (
      ClassificationRulesService.isRelevant(product) &&
      UtilityService.wordMatch(
        product.productTypeLevel2,
        COLLECTIVE_INVESTMENT_TRUST,
      ) &&
      UtilityService.wordMatch(product.productTypeLevel1, TRUST)
    )
  }
}
